<div class="buttons-container">
  <ul class="buttons-container__list">
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="refreshWorkItem()"
        [disabled]="refreshWorkItemDisable()">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="exportToExcel()"
        [disabled]="exportToExcelDisable()">
        <mat-icon>insert_drive_file</mat-icon>
        Export to Excel
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="activateSuspendWorkItem('Active')"
        [disabled]="activateDisable()">
        <mat-icon>check_circle</mat-icon>
        Activate
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="activateSuspendWorkItem('Suspend')"
        [disabled]="suspendDisable()">
        <mat-icon>warning</mat-icon>
        Suspend
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="setDropDown(adminEmitter.reAssign, $event)"
        [disabled]="reAssignDisable()">
        <mat-icon>account_circle</mat-icon>
        Re-Assign
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="assignReleaseWorkItem('RELEASE')"
        [disabled]="releaseDisable()">
        <mat-icon>lock_open_right</mat-icon>
        Release
      </button>
    </li> 
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="deleteWorkItem()" [disabled]="deleteDisable()">
        <mat-icon>delete</mat-icon>
        Delete
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showLineItemsGLEntry()"
        [disabled]="documentHistoryDisable()">
        <mat-icon>description</mat-icon>
        View Line Item / GL Entry
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showViewHistory()"
        [disabled]="workflowHistoryDisable()">
        <mat-icon>history</mat-icon>
        View Workflow History
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showDocumentHistory()"
        [disabled]="documentHistoryDisable()">
        <mat-icon>history</mat-icon>
        View Document History
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showDocumentNotesAdmin()"
        [disabled]="documentNotesDisable()">
        <mat-icon>description</mat-icon>
        View Document Notes
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showViewNotes()"
        [disabled]="workflowNotesDisable()">
        <mat-icon>group_work</mat-icon>
        View / Add Workflow Notes
      </button>
    </li>
  </ul>
</div>
<div class="workflow-container">
  <div class="row col-sm-12 container-class">
    <p class="col-sm-12" style="margin: 4px; font-size: smaller; font-weight: 500;">{{workFlowNil ? 'No workflows available':'Select the workflow/queue to display the workitems'}}</p>
    <div class="queue-wrapper" [class.closed]="!leftQueuePanelOpen">
      <div class="content-left left">
        <mat-card style=" max-height: 100vh; overflow-y: auto;" class="admin-tree">
          <mat-list *ngIf="isQueueTreeLoading"><mat-spinner></mat-spinner></mat-list>
          <mat-list *ngIf="!isQueueTreeLoading">
            <mat-list-item class="queues" *ngFor="let i of adminTreeWorkFlowDetails">
              <mat-expansion-panel #panel [expanded]="expandedPanelId === i.id" (opened)="togglePanel(i.id)">
                <mat-expansion-panel-header class="queue-panel-header">
                  <span>{{i.name}}</span>
                  <mat-icon style="overflow: visible;" *ngIf="panel.expanded">folder_open</mat-icon>
                  <mat-icon style="overflow: visible;" *ngIf="!panel.expanded">folder</mat-icon>
                </mat-expansion-panel-header>
                <mat-list-item style="padding-left: 10px !important;" *ngFor="let j of i?.userWorkflowQueues" [ngClass]="{'active': isQueuesSet(j.id)}">
                  <button mat-button class="queue-btn" (click)="getAdminQueueWorkItemsDetails(j.workflowId, j.id)"
                    [disabled]="isICountNull(j.count) ? true : false">
                    <span class="queue-name">{{ j.name }}</span>
                    <span class="queue-count">({{ j.count }})</span>
                  </button>
                </mat-list-item>
              </mat-expansion-panel>
            </mat-list-item>
          </mat-list>
        </mat-card>
        <mat-card class="work-status" [ngClass]="{'active': isWorkStatusActive}">
          <mat-card-header class="queue-status-header">
            <mat-card-title class="queue-status">
              Queue Status
              <mat-icon *ngIf="isCount">folder_open</mat-icon>
              <mat-icon *ngIf="!isCount">folder</mat-icon>
            </mat-card-title>
          </mat-card-header>
          <div>
            <mat-spinner *ngIf="isQueueStatusLoading"></mat-spinner>
            <div class="card-structure" *ngIf="!isQueueStatusLoading">
              <div class="card-elements">Total: {{ totalCount }}</div>
              <div class="card-elements">Active: {{ activeCount }}</div>
              <div class="card-elements">Suspended: {{ suspendedCount }}</div>
              <div class="card-elements">Assigned: {{ assignedCount }}</div>
              <div class="card-elements">Unassigned: {{ unassignedCount }}</div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <div class="resizer" (click)="toggleLeftQueuePanel()" (keydown.enter)="toggleLeftQueuePanel()" (keydown.space)="toggleLeftQueuePanel(); $event.preventDefault()">
      <mat-icon>{{ leftQueuePanelOpen ? 'chevron_left' : 'chevron_right' }}</mat-icon>
    </div>
    <div class="p-table-wrapper">
      <div class="row" *ngIf="!isDataAvailable && isWorkStatusActive">
        <div class="data-not-found">
          No Data found
        </div>
      </div>
      <div>
      <div *ngIf="isDataAvailable">
        <div class="p-table-max-item">
          <label style="padding-right: 10px;">Max items</label>
          <div class="max-item-wrapper">
            <mat-form-field appearance="outline" class="full-width">
              <mat-select [(value)]="selectedMaxItem" (selectionChange)="getSelectedMaxWorkItems()" panelClass="max-item-wrapper">
                <ng-container >                    
                  <mat-option *ngFor="let item of rowsOptions" [value]="item.value">{{ item.label }}</mat-option>
                </ng-container> 
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
        <p-table #workflowGrid *ngIf="isDataAvailable"
        [columns]="columns" 
        [value]="workItems"
        [paginator]="true" 
        [rows]="rows"  
        [(selection)]="selectedWorkItems"
        [sortField]="sortField" 
        [sortOrder]="sortOrder"
        (onColReorder)="onColumnReordered($event)"
        [reorderableColumns]="true"  
        sortMode="multiple"
        [loading]="isTableLoading" 
        [loadingIcon]="''" 
        [resizableColumns]="true"
        columnResizeMode="expand">
          <ng-template pTemplate="paginatorright">
            <div class="p-text-right">
              <label for="perPage" class="p-mr-2">Items per page:</label>
              <select id="perPage" class="p-inputtext" (change)="onRowsChange($event )">
                <option *ngFor="let option of rowsOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" pReorderableColumn pResizableColumn scope="col">
                <div class="top-div">
                  <div class="text-section"><span [pSortableColumn]="col.field">{{ col.title }}</span></div>
                  <div class="spacer"><p-sortIcon [field]="col.field" /></div>
                  <div>
                    <p-columnFilter class="icon-section" [ngClass]="{'active': col.advancefilter.isAdvanceFilterUsed}" #filterRef [type]="col.type" [field]="col.field" 
                      display="menu" [showMatchModes]="false" [showOperator]="false" [filterModel]="col.advancefilter"> 
                      <ng-template pTemplate="filter" let-values let-filter="filterCallback" let-index="index">
                        <div class="rules-holder" *ngFor="let constraint of col.advancefilter!.constraints; let i = index" >
                          <p *ngIf="i === 0">Show items with value that:</p>
                          <p-dropdown class="p-dropdown"
                            [options]="col.advancefilter!.matchModeOptions" [(ngModel)]="constraint.matchMode"
                            optionLabel="label" optionValue="value"
                            (change)="onMatchModeChange($event, col.field, i)"/> 
                    
                          <input *ngIf="col.type == 'string' || col.type == 'number'"
                            type="text" pInputText class="p-inputtext" [value]="constraint.value"
                            (input)="onRuleChange($event, col.field, i)"/> 

                          <p-calendar class="p-calendar" *ngIf="col.type == 'date'"
                          [(ngModel)]="constraint.value" (onSelect)="onDateRuleChange($event, col.field, i)"
                          [showTime]="true" [hourFormat]="'12'" [showIcon]="true"
                          [placeholder]="'Select date and time'"></p-calendar>
                            
                          <div class="operator" *ngIf="i === 0" > 
                            <p-dropdown [options]="[
                                { label: 'And', value: 'and' },
                                { label: 'Or', value: 'or' }
                              ]"
                              [(ngModel)]="col.advancefilter.operator"
                              (onChange)="onOperatorChange($event, col.field)"
                              class="p-dropdown" >
                            </p-dropdown>
                          </div>
                        </div>
                        <div class="p-d-flex p-jc-end p-ai-center p-gap-2">
                          <button pButton type="button" label="Apply" 
                                  class="p-button-primary p-button-sm"
                                  (click)="applyCall(col, filterRef)">
                          </button>
                          <button pButton type="button" label="Clear" 
                                  class="p-button-secondary p-button-sm"
                                  (click)="clearCall(col, filter, filterRef)">
                          </button>
                        </div>
                      </ng-template> 
                    </p-columnFilter>
                  </div>
                </div>
                <div class="bottom-div">
                  <p-columnFilter [field]="col.field" matchMode="in" [showMenu]="false"
                    (onClear)="customClear(col)">
                    <ng-template pTemplate="filter">
                      <p-multiSelect [options]="col.filterOptions"
                      placeholder="Select" (onChange)="customFilter(col.type)" 
                      [(ngModel)]="filters[col.field]" [optionLabel]="'label'"
                      appendTo="body" [panelStyle]="{'z-index': '1000'}">
                        <ng-template let-option pTemplate="item">
                          <div class="inline-block vertical-align-middle">
                            <span class="ml-1 mt-1">{{ option['label'] }}</span>
                          </div> 
                        </ng-template>
                      </p-multiSelect> 
                    </ng-template> 
                  </p-columnFilter>  
                  <button class="clear-button" mat-icon-button
                      *ngIf="filters[col.field]?.length || col.advancefilter.isAdvanceFilterUsed" 
                      (click)="customClear(col)"><mat-icon class="clear-button-icon">close</mat-icon>
                  </button> 
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-selected="selected" let-index="rowIndex">
            <tr [pSelectableRow]="rowData" [class.selected-row]="selected"
              [ngClass]="{ 'p-highlight': isSelected(index) }" 
              (click)="onRowClick($event, index)" (mousedown)="onMouseDown($event, index)"
              (mouseover)="onMouseOver($event, index)" (mouseup)="onMouseUp($event)" (keydown)="onRowKeydown($event, index)" (focus)="onRowFocus($event, index)">
              <td *ngFor="let col of columns" (dblclick)="copyToClipboard(rowData[col.field])">
                <ng-container [ngSwitch]="col.field">
                  <ng-container *ngSwitchCase="'InstanceId'">
                    <a (click)="openDocument(rowData['view_Document'], $event)" (contextmenu)="handleRightClick($event)">{{ rowData[col.field] }}</a>
                  </ng-container> 
                  <ng-container *ngSwitchDefault>
                    {{ rowData[col.field] }}
                  </ng-container>
                </ng-container>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft" let-state>
            <div class="custom-paginator-text">
              {{ state.first + 1 }} - {{ min(state.first + state.rows, state.totalRecords) }} of {{ state.totalRecords }} items
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>